import { createAtomState } from '@/ui/utilities/state/jotai/utils/createAtomState';

// Set when the server answers UNAUTHENTICATED to any request. With the mock
// sign-in, the session gate then shows the signed-out screen; with Clerk, the
// Clerk gate ends the session and opens the sign-in page.
export const isSignedOutState = createAtomState<boolean>({
  key: 'isSignedOutState',
  defaultValue: false,
});
